import React from "react"

export default props => {
  return (
    <p>
      <span>{props.span}</span>
      {props.paragraph}
    </p>
  )
}
